module.exports = __webpack_public_path__ + "fonts/raleway-regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Raleway/raleway-regular-webfont.woff
// module id = 3453
// module chunks = 0